/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Unable_Open_PortalInputs */



/**
* | output |
* | --- |
* | "Unable to open subscription portal." |
*
* @param {Pricing_Unable_Open_PortalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_unable_open_portal = /** @type {((inputs?: Pricing_Unable_Open_PortalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Unable_Open_PortalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Abonnement-Portal konnte nicht geöffnet werden.")
	return /** @type {LocalizedString} */ ("Unable to open subscription portal.")
});